

<header>
  <app-header-sticky-front-office #comp2Context></app-header-sticky-front-office>
</header>

<section [class.desktop-offset]="isDesktopDevice" [class.mobile-offset]="isMobile || isTablet">
  <mat-card appearance="outlined">

    <br>
      <br>
        <br>
          <br>
            <br>
              <div class="col">
                <!--<iframe src="https://get.cryptobrowser.site/pb/4/29246707/?t=simple,text,pro,mobile" style="width: 300px; height: 250px" frameborder="no"></iframe> -->
              </div>
              <!-- <button (click)="myElement.scrollIntoView({ behavior: 'smooth', block: 'start' })">
              Click to scroll
            </button> -->

            <div class="home-layout" [class.home-layout-desktop]="isDesktopDevice">
              <div class="home-main">
                <router-outlet></router-outlet>
              </div>
              @if (isDesktopDevice && showSidebar) {
                <aside class="home-sidebar">
                  <app-hot-deals-sidebar></app-hot-deals-sidebar>
                  <app-sidebar-ad></app-sidebar-ad>
                  <app-partners-sidebar></app-partners-sidebar>
                  <app-tech-news-sidebar></app-tech-news-sidebar>
                </aside>
              }
            </div>

            <!-- <div class="col">
            <iframe src="https://get.cryptobrowser.site/pb/4/29246707/?t=simple,text,pro,mobile" style="width: 300px; height: 250px" frameborder="no"></iframe>
          </div> -->

        </mat-card>
      </section>

      <!--  <footer>
      <div style="background-color: #292c2f;">
        <br>
          <app-footer app-footer></app-footer>
        </div>
      </footer>-->

      <!-- <button (click)="myTopElement.scrollIntoView({ behavior: 'smooth', block: 'start' })">
      Click to scroll to top element
    </button> -->

    @if (isDesktopDevice) {
      <footer>
        <div>
          <br>
            <app-footer app-footer></app-footer>
          </div>
        </footer>
      }
      <app-cookie-dialog ></app-cookie-dialog>
      @if (isDesktopDevice) {
        <app-nav-bar-footer-stiky ></app-nav-bar-footer-stiky>
      }
      @if (isMobile || isTablet) {
        <app-nav-bar-footer-mobile  [headerStickyFrontOfficeComponent]="comp2Context"></app-nav-bar-footer-mobile>
      }
